import Encrypt from 'enos-encrypt';
import {message} from '@enos/dpl';
import localeText from '@locale';
import uris from '~/uris';

const encrypt = new Encrypt();

export function rsaEncrypt(text) {
  return encrypt.RSA.encrypt(text);
}

export function getPublicKey() {
  return encrypt.RSA.getPublicKey(uris.getPublicKey()).catch((error) => {
    message.error(localeText('COMMON.HINT_INVALID_PUBLIC_KEY'));
    return Promise.reject(error);
  });
}

export function edgeEncryptConfig() {
  const {iv, aesKey, publicKeyId: keyId} = encrypt.config;
  return {iv, keyId, aesKey: rsaEncrypt(aesKey)};
}

export default encrypt;
